export const FINISH_MY_DESIGN = 'FINISH_MY_DESIGN';
export const SET_RECIPE_FINISH_MY_DESIGN = 'SET_RECIPE_FINISH_MY_DESIGN';
export const SET_LOADING_FINISH_MY_DESIGN = 'SET_LOADING_FINISH_MY_DESIGN';
